// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2MKAq","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1r413"};